import { useCallback, useContext } from 'react';

import { gtmContext } from '@/contexts/gtmContext/gtmContext';
import { mixpanelContext } from '@/contexts/mixpanelContext';

type GTMTracker = {
  track: (
    event: string,
    sendToMixpanel: boolean,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    args?: Record<string, any>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mixpanelOnlyArgs?: Record<string, any>
  ) => void;
};

const useGTM = (): GTMTracker => {
  const _gtm = useContext(gtmContext);
  const _mixpanel = useContext(mixpanelContext);
  const track = useCallback(
    (
      event: string,
      sendToMixpanel: boolean = false,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      args?: Record<string, any>,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      mixpanelOnlyArgs?: Record<string, any>
    ) => {
      _gtm?.push(event, args);
      if (sendToMixpanel) {
        _mixpanel?.track(event, { ...args, ...mixpanelOnlyArgs });
      }
    },
    [_gtm, _mixpanel]
  );

  return { track };
};

export default useGTM;
